import { AdditionalFilter } from './additional-filter';
import { RulebookFilter } from './rulebook.model';

export class RulebookFilterModel extends AdditionalFilter {
    fromDate: string;
    toDate: string;
    libraryName: string;
    rulebookName: string;
    rulebook: string[];
    geography: string[];
    country: string[];
    isShowAllRule: boolean;
    isLatestVersion: boolean;
    headers:string[];
    ruleText:string[];
    relatedProvisions:string[];
    spiderLinks:string[];
    owner: string[];
    obligation:string[];
    risk: string[];
    controls: string[];
    summary: string[];
    interpretation: string[];
    linkedControls:string[];
    rulebookId: number[];
    roleId:number;

    constructor() {
        super();
        this.fromDate = '';
        this.toDate = '';
        this.libraryName = '';
        this.rulebookName = '';
        this.rulebook = [];
        this.geography = [];
        this.country = [];
        this.isShowAllRule = false;
        this.isLatestVersion =  false;
        this.headers = [];
        this.ruleText = [];
        this.relatedProvisions = [];
        this.spiderLinks = [];
        this.owner = [];
        this.obligation = [];
        this.risk = [];
        this.controls = [];
        this.summary = [];
        this.interpretation = [];
        this.linkedControls = [];
        this.rulebookId = [];
        this.roleId=0;
    }
}
export class BrifRulebookFilterModel extends RulebookFilter{
   // rulebookName: string;
    connectionHeader:string;
    instruction:boolean
    constructor() {
        super(); 
        //this.rulebookName = '';
        this.connectionHeader = '';
        this.instruction = false;
    }
}
